import { render, staticRenderFns } from "./psp-scores-chart.vue?vue&type=template&id=dc6d7924"
import script from "./psp-scores-chart.vue?vue&type=script&lang=js"
export * from "./psp-scores-chart.vue?vue&type=script&lang=js"
import style0 from "./psp-scores-chart.vue?vue&type=style&index=0&id=dc6d7924&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports